/*jslint browser: true, fudge: true, long: true */
/*global $, blacksunplc, document, window */

blacksunplc.events.ready(function () {
    "use strict";

    var navigationWrapper = $(".main-nav");

    $(".hamburger").on("click", function (event) {
        event.stopPropagation();
        var button = $(event.currentTarget);
        button.addClass("is-active");
        navigationWrapper.addClass("is-active");
    });

    function closeNavigation() {
        $(".hamburger").removeClass("is-active");
        navigationWrapper.removeClass("is-active");
    }

    navigationWrapper.on("click", ".main-nav__close", function (event) {
        event.preventDefault();
        closeNavigation();
    });

    navigationWrapper.on("click", function (event) {
        event.stopPropagation();
    });

    $(document).on("click", function () {
        closeNavigation();
    });

    if ($(".pillar").length > 0 && $(window).width > 840) {
        var headingHeight = 0;

        $(".pillar .row").each(function () {
            headingHeight = 0;

            $(this).find("h6").each(function () {
                if ($(this).outerHeight() > headingHeight) {
                    headingHeight = $(this).outerHeight();
                }
            });

            $(this).find("h6").css("height", headingHeight + "px");
        });
    }

    function scrollToElement(element, topSpacing) {
        $("html, body").animate({
            scrollTop: element.offset().top - topSpacing
        }, 500);
    }

    function gotoSectionNavigaion() {
        $(".page-body__navigation").on("click", "a", function (event) {
            event.preventDefault();
            var anchore = $(event.currentTarget);
            var id = anchore.attr("href");
            if ($(id).parents(".bs-accordion").length) {
                var accButton = id.replace("#", "");
                var button = $(".bs-accordion__header button[aria-controls=" + accButton + "]");
                button.click();
                setTimeout(function () {
                    scrollToElement(button, 70);
                }, 300);
            } else {
                scrollToElement($(id), 100);
            }
        });
    }

    function resizeGallery() {

        if ($(window).width() > 820) {
            $(".pillar__gallery").each(function () {
                var titleHeight = 0;
                var outerHeight = 0;

                $(this).find("h6").each(function () {
                    outerHeight = $(this).outerHeight();
                    if (outerHeight > titleHeight) {
                        titleHeight = outerHeight;
                    }
                });

                $(this).find("h6").css("height", titleHeight + "px");
            });
        }
    }
    function resizeGalleryImage() {

        if ($(window).width() > 820) {
            $(".pillar__gallery").each(function () {
                var imgHeight = 0;
                var outerImageHeight = 0;
            
                $(this).find(".img-container").each(function () {
                    outerImageHeight = $(this).outerHeight();

                    if (outerImageHeight > imgHeight) {
                        imgHeight = outerImageHeight;
                    }
                });

                $(this).find(".img-container").css("height", imgHeight + "px");
            });
        }
    }

    function dividendCart() {
        if ($(window).width() > 820) {
            var itemHeight = 0;
            $(".dividends-chart .item li").each(function () {

                var outerHeight = $(this).outerHeight();
                if (outerHeight > itemHeight) {
                    itemHeight = outerHeight;
                }

            });
            $(".dividends-chart .item li").css("height", itemHeight + "px");
        }
    }


    resizeGallery();
    dividendCart();

    setTimeout(function() {
        resizeGalleryImage();
    }, 1000);
    gotoSectionNavigaion();
});
